import React, { useState } from 'react';

const Gst = () => {
  const [selectedService, setSelectedService] = useState('registration');

  const services = [
    { key: 'registration', label: 'GST Registration' },
    { key: 'filing', label: 'GST Filing' },
  ];

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center">Goods and Services Tax (GST)</h1>
       <p className="text-md text-justify text-[#444] mb-8">Our experienced tax consultants specialize in assisting customers with Goods and Services Tax (GST) registration for new businesses, guiding them through every step of the process to ensure compliance with current tax regulations. From gathering necessary documentation to completing the online application, our experts ensure a smooth registration experience, helping clients navigate the complexities of GST registration with ease. Once registration is complete, we also provide ongoing support for GST filing, offering comprehensive services that include accurate preparation and timely submission of GST returns. Our team is committed to keeping our clients informed about compliance requirements and deadlines, allowing them to focus on their core business activities while ensuring they meet all tax obligations efficiently. With our expert assistance, customers can confidently manage their GST responsibilities and maintain full compliance with the law</p>
      {/* Toggle Buttons */}
      <div className="flex justify-center gap-4 mb-8">
        {services.map((service) => (
          <button
            key={service.key}
            onClick={() => setSelectedService(service.key)}
            className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
              selectedService === service.key
                ? 'bg-[#b7b7a1] text-white'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
            }`}
          >
            {service.label}
          </button>
        ))}
      </div>

      {/* Conditional Content */}
      <div className="space-y-4 text-justify text-gray-800 text-sm leading-relaxed bg-white p-6 rounded-xl shadow">
       {selectedService === 'registration' && (
  <>
    <p>
      <strong>Goods and Services Tax (GST) registration</strong> is a process through which businesses or individuals become taxpayers under the GST law. This registration is essential for conducting commercial activities involving the supply of goods and/or services. Upon registration, the business is assigned a unique Goods and Services Tax Identification Number (GSTIN).
    </p>

    <h3 className="font-semibold mt-4">Key Features of GST Registration</h3>
    <ul className="list-disc pl-5 space-y-1">
      <li><strong>Unique Identification Number:</strong> GSTIN is necessary for tax compliance and is used for all GST-related transactions.</li>
      <li><strong>Input Tax Credit (ITC):</strong> Registered taxpayers can claim a credit for the tax paid on inputs used in their business, reducing overall tax liability.</li>
      <li><strong>Tax Compliance:</strong> Ensures adherence to GST regulations, enabling accurate collection and remittance of taxes.</li>
      <li><strong>Inter-State Operations:</strong> Mandatory for businesses engaged in inter-state supply of goods and services.</li>
      <li><strong>Legitimacy:</strong> Enhances business credibility and trustworthiness.</li>
    </ul>

    <h3 className="font-semibold mt-4">Necessity of GST Registration</h3>
    <ul className="list-disc pl-5 space-y-1">
      <li><strong>Legal Requirement:</strong> Most countries have defined turnover thresholds. Businesses crossing this must register under GST.</li>
      <li><strong>Facilitation of Trade:</strong> Enables easier inter-state trade with smoother logistics and compliance.</li>
      <li><strong>Claiming Input Tax Credit:</strong> Helps lower tax liability by offsetting GST paid on purchases.</li>
      <li><strong>Greater Market Reach:</strong> Enables participation in government contracts, tenders, and collaborations.</li>
      <li><strong>Consumer Trust:</strong> Signifies transparency and compliance in financial dealings.</li>
      <li><strong>Avoiding Penalties:</strong> Timely registration avoids fines and legal complications.</li>
      <li><strong>Access to Benefits:</strong> Allows eligibility for government schemes, refunds, and incentives.</li>
    </ul>

    <h3 className="font-semibold mt-4">Conclusion</h3>
    <p>
      GST registration serves multiple vital functions for businesses, from ensuring compliance with tax regulations to enhancing credibility and facilitating business growth. It is a significant step for any enterprise aiming to operate legally and efficiently within the framework of the modern tax system. By understanding its necessity, businesses can better navigate their obligations and harness the advantages of being a registered taxpayer under GST.
    </p>
  </>
)}


       {selectedService === 'filing' && (
  <>
    <p>
      <strong>GST filing</strong> refers to submitting GST returns to the tax authorities, detailing the income, sales, purchases, and tax collected or paid during a specific period. These returns provide information required under the Goods and Services Tax (GST) framework, helping tax authorities track tax liabilities and ensure compliance with tax laws. Depending on the country and business circumstances, GST returns may need to be filed monthly, quarterly, or annually.
    </p>

    <h3 className="font-semibold mt-4">Types of GST Returns</h3>
    <p>Different types of GST returns are applicable depending on the category of taxpayer (regular, composition, etc.) and the nature of goods and services provided. Common types include:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li><strong>GSTR-1:</strong> Details of outward supplies (sales) made by the taxpayer.</li>
      <li><strong>GSTR-2:</strong> Details of inward supplies (purchases) the taxpayer receives.</li>
      <li><strong>GSTR-3:</strong> Summary of sales and purchases along with tax liabilities.</li>
      <li><strong>GSTR-9:</strong> Annual return for regular taxpayers.</li>
      <li><strong>GSTR-3B:</strong> A simplified return summarising sales and tax liability.</li>
    </ul>

    <h3 className="font-semibold mt-4">Necessity of GST Filing</h3>
    <ul className="list-disc pl-5 space-y-1">
      <li><strong>Legal Requirement:</strong> Filing GST returns is a legal obligation for all registered businesses. Non-compliance can lead to penalties, fines, and legal repercussions.</li>
      <li><strong>Tax Compliance:</strong> Regular filing ensures businesses remain compliant with the tax laws, helping them avoid audits and legal issues.</li>
      <li><strong>Maintaining Input Tax Credit (ITC):</strong> Timely filing is crucial for claiming ITC. Without it, businesses may lose input credits, increasing tax liability.</li>
      <li><strong>Financial Reporting:</strong> Returns help track sales, purchases, and tax liabilities—supporting better financial decision-making.</li>
      <li><strong>Avoiding Penalties:</strong> Accurate and timely filing helps avoid penalties and interest charges.</li>
      <li><strong>Transparency and Accountability:</strong> Filing promotes financial transparency, building trust with customers, investors, and authorities.</li>
      <li><strong>Facilitating Business Operations:</strong> Staying compliant allows smooth participation in tenders, contracts, and partnerships.</li>
      <li><strong>Access to Refunds:</strong> If more tax is paid on purchases than collected on sales, timely filing ensures eligibility for refunds and improves cash flow.</li>
    </ul>

    <h3 className="font-semibold mt-4">Conclusion</h3>
    <p>
      GST filing is a crucial aspect of the GST compliance process that ensures transparency, accountability, and legal adherence for businesses. Regular filing facilitates effective tax management, helps businesses maximize their financial benefits, and maintains a positive relationship with tax authorities. Understanding the importance of filing GST returns empowers businesses to operate efficiently and avoid unnecessary legal complications.
    </p>
  </>
)}

      </div>
    </div>
  );
};

export default Gst;
